import React from 'react';
import PropTypes from 'prop-types';
import NavigationButton from '@client/components/designSystem/navigationButton/NavigationButton';
import styles from './adminSidebar.scss';

const itemShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool,
  Icon: PropTypes.elementType,
});

function NavItem({ item, onNavigate }) {
  const { Icon } = item;
  return (
    <NavigationButton
      to={item.to}
      icon={Icon ? <Icon /> : undefined}
      active={item.isCurrent}
      onClick={onNavigate}
    >
      {item.label}
    </NavigationButton>
  );
}

NavItem.propTypes = {
  item: itemShape.isRequired,
  onNavigate: PropTypes.func,
};

// The main sections, then the policies and Settings. One landmark, so a
// screen reader announces it once.
function SidebarNavigation({ sections, policies, settings, onNavigate }) {
  return (
    <nav aria-label="Main navigation" className={styles.navigation}>
      <div className={styles.sections}>
        {sections.map((item) => (
          <NavItem key={item.key} item={item} onNavigate={onNavigate} />
        ))}
      </div>
      <div className={styles.footerGroup}>
        <div role="group" aria-labelledby="admin-sidebar-policies">
          <p id="admin-sidebar-policies" className={styles.groupLabel}>
            Policies
          </p>
          {policies.map((item) => (
            <NavItem key={item.key} item={item} onNavigate={onNavigate} />
          ))}
        </div>
        <NavItem item={settings} onNavigate={onNavigate} />
      </div>
    </nav>
  );
}

SidebarNavigation.propTypes = {
  sections: PropTypes.arrayOf(itemShape).isRequired,
  policies: PropTypes.arrayOf(itemShape).isRequired,
  settings: itemShape.isRequired,
  onNavigate: PropTypes.func,
};

export default SidebarNavigation;
